import { render } from "./InviteForm.vue?vue&type=template&id=7c7459b6&scoped=true"
import script from "./InviteForm.vue?vue&type=script&lang=js"
export * from "./InviteForm.vue?vue&type=script&lang=js"

import "./InviteForm.vue?vue&type=style&index=0&id=7c7459b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c7459b6"]])

export default __exports__